import * as FullStory from '@fullstory/browser'
import { isFullStoryEnabled } from 'config/portal'

/* eslint-disable no-console */
const commonLogger = (eventName, eventProperties = {}) => {
  if (!isFullStoryEnabled() || globalThis.Cypress) return
  try {
    FullStory.event(eventName, {
      page: globalThis.location.pathname,
      ...eventProperties,
    })
  } catch (error) {
    // Fail silently if FullStory is not available or if there's an error with logging
    console.error('Error logging event to FullStory:', error)
  }
}

export default commonLogger
